<template>
	<!-- 打印设置 -->
	<el-dialog title="打印设置" :visible.sync="printSetDialog" :close-on-click-modal="false" :show-close="false" v-el-drag-dialog width="30%">
		<el-form label-width="100px" style="padding-right: 30px;">
			<el-form-item label="纸张">
				<el-select v-model="pageType" placeholder="打印纸" style="margin-right: 10px;">
					<el-option v-for="item in pageTypeList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="表格字号">
				<el-input v-model="printFontSize" placeholder="请输入字号" type="number"></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="warning" @click="printSetConfirmFn">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		name: "PrintSetting",
		props: ["printSetDialog"],
		data() {
			return {
				printFontSize: 14,
				pageType: 1,
				pageTypeItem: {
					id: 1,
					name: '针式三等分多联纸',
					width: 2410,
					height: 930
				},
				pageTypeList: [{
					id: 1,
					name: '针式三等分多联纸',
					width: 2410,
					height: 930
				}, {
					id: 2,
					name: '针式二等分多联纸',
					width: 2410,
					height: 1400
				}, {
					id: 3,
					name: '针式一等分多联纸',
					width: 2410,
					height: 2800
				}, {
					id: 4,
					name: '标准A4纸',
					width: 2100,
					height: 2970
				}, {
					id: 5,
					name: '标准A5纸',
					width: 2100,
					height: 1480
				}],
			};
		},
		mounted() {
			this.pageType = localStorage.getItem("defaultPageType") ?? '1';
			this.pageType = Number(this.pageType)
			if (localStorage.getItem("defaultPageTypeItem")) {
				this.pageTypeItem = JSON.parse(localStorage.getItem("defaultPageTypeItem"));
			} else {
				this.pageTypeItem = {
					id: 1,
					name: '针式三等分多联纸',
					width: 2410,
					height: 930
				};
			}

			if (localStorage.getItem("printFontSize")) {
				this.printFontSize = localStorage.getItem("printFontSize")
			}
		},
		methods: {
			printSetConfirmFn() {
			
				let that = this
				that.pageTypeList.forEach(item => {
					if (item.id == that.pageType) {
						that.pageTypeItem = item
					}
				})
				localStorage.setItem("defaultPageType", that.pageType);
				localStorage.setItem("defaultPageTypeItem", JSON.stringify(that.pageTypeItem));
					localStorage.setItem("printFontSize", that.printFontSize);
				
				this.$emit('callback', {
					fontSize: this.printFontSize,
					pageType: this.pageType,
					pageTypeItem: this.pageTypeItem
				});
			},
			handleSearch() {
				if (this.loading) return;
				this.loading = true
				this.page = 1
				this.searchForm.begin = this.dateVal[0]
				this.searchForm.end = this.dateVal[1]
				this.searchForm.is_settle = this.searchForm.is_settle == 2 ? '' : this.searchForm.is_settle
				this.getList()
			},
		}
	}
</script>

<style>
</style>